import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ClientEsbConfigMap } from '@avalara/types/esb';
import type { EsbState } from '@avalara/types/reducer-states';

const initialState: EsbState = {
  connectorReturnUrl: '',
  esbConfigMap: null,
  esbPartner: null,
  esbSignupKey: null,
  esbPath: 'start-trial',
};

const store = createSlice({
  name: 'esb',
  initialState,
  reducers: {
    setEsbConfigMap: (state, action: PayloadAction<ClientEsbConfigMap>) => {
      state.esbConfigMap = action.payload;
    },
    setEsbConnectorReturnUrl: (state, action: PayloadAction<string>) => {
      state.connectorReturnUrl = action.payload;
    },
    setEsbPartner: (state, action: PayloadAction<string>) => {
      state.esbPartner = action.payload;
    },
    setEsbPath: (state, action: PayloadAction<string>) => {
      state.esbPath = action.payload;
    },
    setEsbSignupKey: (state, action: PayloadAction<string>) => {
      state.esbSignupKey = action.payload;
    },
  },
});

export const { setEsbConfigMap, setEsbConnectorReturnUrl, setEsbPartner, setEsbPath, setEsbSignupKey } = store.actions;

export default store;
